const formatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'VND',
});

export function formatCurrency(num: number) {
  return formatter.format(num);
}
